<template lang="pug">
extends ../../../../prototype/src/pug/layout/section_two_column_gray
block left
	.posto_de_atendimento__panel
		.markdown.posto_de_atendimento__text_block
			h1 Encontre o posto de atendimento mais próximo

			p Unidades disponíveis por todo o Brasil para você validar seu Certificado Digital.

	.posto_de_atendimento__form--wrapper
		.posto_de_atendimento__form--fields
			.posto_de_atendimento__form--field
				input(placeholder="Digite o Bairro, Cidade ou Estado", 'v-model'="term")

	.posto_de_atendimento__results
		.posto_de_atendimento__no_match(v-if="results.length == 0") Nenhum resultado encontrado
		PostoAtendimentoResultItem('v-for'="row in results", :row="row", @fireChangeMap="updateMap", 'v-if'="results")

block right
	a(:href="map_link", target="_blank").posto_de_atendimento__map
		img(:src="mapa")

block variables
	- var id = "posto_de_atendimento"
	- var class_right_column = "posto_de_atendimento__column--right"

</template>

<script>
import Images from "@/assets/images.json";
import PostoAtendimentoResultItem from "@/components/posto_atendimento/PostoAtendimentoResultItem.vue";

export default {
	name: "PostoAtendimento",
	components: {
		PostoAtendimentoResultItem
	},
	data: function() {
		return {
			term: '',
			selection: process.env.BASE_URL + 'images/mapa.png',
			map_link: "javascript:void(0);",
			BASE_URL: process.env.BASE_URL
		}
	},
	methods: {
		updateMap: function(row) {
			// this.selection = process.env.BASE_URL + 'images/mapas/' + row.id + '.png';
			this.map_link = row.url;
		},
		normalize: function(text) {
			return text.toLowerCase().replace(/ /gi, '-').replace(/&/gi, '').replace(/\(/gi, '').replace(/\)/gi, '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\?/gi, '');
		}
	},
	computed: {
		mapa: function() {
			return this.selection;
		},
		results: function() {
			if (this.term.length > 3) {
				const result = [];

				for (let index = 0; index < Images.length; index++) {
					const element = Images[index];
					
					if (this.normalize(element.estado).indexOf(this.normalize(this.term)) > -1) {
						element.url = "https://www.google.com/maps/search/?api=1&query=" + [element.endereco, element.cidade, element.estado].join(', ');
						result.push(element);
						continue;
					}

					if (this.normalize(element.cidade).indexOf(this.normalize(this.term)) > -1) {
						element.url = "https://www.google.com/maps/search/?api=1&query=" + [element.endereco, element.cidade, element.estado].join(', ');
						result.push(element);
						continue;
					}

					if (this.normalize(element.name).indexOf(this.normalize(this.term)) > -1) {
						element.url = "https://www.google.com/maps/search/?api=1&query=" + [element.endereco, element.cidade, element.estado].join(', ');
						result.push(element);
						continue;
					}

					if (this.normalize(element.endereco).indexOf(this.normalize(this.term)) > -1) {
						element.url = "https://www.google.com/maps/search/?api=1&query=" + [element.endereco, element.cidade, element.estado].join(', ');
						result.push(element);
						continue;
					}
				}

				return result;
			}

			return false;
		}
	}
}
</script>